import React from 'react'
import PropTypes from 'prop-types'
import { Box, LinearProgress, Typography } from '@material-ui/core'

import { DashboardTablePaper } from 'components'

import useStyles from '../../styles'

const PhishingProgressTable = ({ title, rows }) => {
  const classes = useStyles()

  return (
    <DashboardTablePaper title={title} className={classes.tableRoot}>
      {rows?.map((row) => (
        <Box px={2} py={1} key={row.name}>
          <Box className={classes.lineTitle}>
            <Typography className={classes.rowName}>{row.name}</Typography>
            <Typography className={classes.rowValue}>{row.value}</Typography>
          </Box>
          <LinearProgress
            classes={{
              root: classes.lineBar,
              bar: row.barClass,
              colorPrimary: classes.lineBarTrack,
            }}
            variant="determinate"
            value={row.percentage}
          />
        </Box>
      ))}
    </DashboardTablePaper>
  )
}

PhishingProgressTable.propTypes = {
  title: PropTypes.string,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
      percentage: PropTypes.number,
      barClass: PropTypes.string,
    }),
  ),
}

export default PhishingProgressTable
